import { render, staticRenderFns } from "./PlatformDashboard.vue?vue&type=template&id=7e846a66&scoped=true&"
import script from "./PlatformDashboard.vue?vue&type=script&lang=js&"
export * from "./PlatformDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PlatformDashboard.vue?vue&type=style&index=0&id=7e846a66&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e846a66",
  null
  
)

export default component.exports